var exports = {
  "kJ": "ThemeEmbed.module__iconCircle___MVhSST",
  "SP": "ThemeEmbed.module__iconCircleActive___MVhSST",
  "GP": "ThemeEmbed.module__iconOnBrand___MVhSST",
};

module.exports = exports;
